<template>
  <portal :to="PostalNames.PreloaderOverlay">
    <div class="preloader-wrapper" :class="[customClasses, 'secondary']">
      <div class="spinner-border text-primary" role="status">
        <span class="sr-only">Loading...</span>
      </div>
    </div>
  </portal>
</template>

<script>
import { PostalNames } from '@/constants/PortalNames'

export default {
  name: 'Preloader',
  data () {
    return {
      PostalNames
    }
  },
  props: {
    customClasses: {
      type: String,
      default: ''
    },
    variant: {
      type: String,
      default: 'primary',
      validator (value) {
        // Check if all elements are strings
        return ['primary', 'secondary'].includes(value)
      }
    }
  }
}
</script>

<style lang="scss" scoped>
.preloader-wrapper {
  z-index: calc($navigationMenuZIndex - 3);
  width: 100%;
  height: 100%;
  min-height: 100vh;
  min-width: 100vh;
  position: absolute;
  left: 0;
  top: 0;
  display: flex;
  align-items: center;
  justify-content: center;
  background-color: rgba(255, 255, 255, 0.7);
}

.secondary {
  background-color: $bgOverlay;
}

.spinner-border {
  width: 64px;
  height: 64px;
  border-color: $sinnerColor $sinnerColor $sinnerColor transparent;
  border-width: 6px;
}
</style>
